import Axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios'

import { generateApplicationUrl } from '@domain-group/javascript-utils'

import { getAccessToken } from '@functions/accessToken'

type Environments = 'development' | 'production' | 'staging' | 'qa' | 'test'

const urls = {
  development: 'http://localhost:3002/api/v3',
  production: 'https://realhub.realbase.io/api/v3',
  staging: 'https://realhub.staging.realbase.io/api/v3',
  qa: 'https://realhub.qa.realbase.io/api/v3',
  test: 'http://localhost:3002/api/v3',
}

const realhubUrls = generateApplicationUrl({
  applicationKey: 'realhub_legacy',
  environment: process.env.REACT_APP_APPLICATION_ENV! as Environments,
})

export const baseURL = urls[process.env.REACT_APP_APPLICATION_ENV! as Environments]
export const baseURLWithoutVersion = realhubUrls?.applicationUrl

const axiosConfig: AxiosRequestConfig = {
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

const axios: AxiosInstance = Axios.create(axiosConfig)

axios.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const accessToken = getAccessToken()

    if (accessToken){
      config.headers.Authorization = `Bearer ${accessToken}`
    }

    return config
  },
  error => Promise.reject(error),
)

const baseConfig: AxiosRequestConfig = {
  method: 'get',
}

const api = (
  url: string,
  options: any = {},
  config: AxiosRequestConfig = {},
) => {
  const mergedConfig: AxiosRequestConfig = { ...baseConfig, ...config }

  // Remove entityKey from options to avoid sending it as a query parameter
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { entityKey, ...requestOptions } = options

  return axios({
    ...mergedConfig,
    params: requestOptions,
    url,
  })
}

export default api
